import { useMutation } from '@tanstack/react-query';

import type { ChangePasswordRequest } from './PasswordManagementClient';
import { PasswordManagementClient } from './PasswordManagementClient';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const useChangePassword = ({ onSuccess, onError }: Props) => {
  const { mutate, isPending } = useMutation({
    mutationFn: (data: ChangePasswordRequest) =>
      PasswordManagementClient.changePassword(data),
    onSuccess,
    onError,
  });

  return {
    changePassword: mutate,
    isLoading: isPending,
  };
};
